import { Paragraph } from "./Text";
import { useColors } from "./useColors";

export const Divider = (props: React.ComponentProps<typeof Paragraph>) => {
  const { subtitleColor } = useColors();

  return (
    <Paragraph align="center" color={subtitleColor} {...props}>
      ⁂
    </Paragraph>
  );
};
